<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/vl1WU/tc-custom/9781488012037.jpg?1730288458515" alt="This image is the cover for the book Snowed in with a Billionaire, Secrets of the A-List"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Snowed in with a Billionaire, Secrets of the A-List
      </h1>
      <p class="bookDescription body article font2">
        <b>There’s a sexy secret under the tree this Christmas in this scintillating holiday romance from the author of <i>The CEO Daddy Next Door</i>.</b><br/><br/>With no money and her real name under wraps, chef Joy McKinley isn’t expecting the greatest Christmas. At least her hideout is a luxury mountaintop estate. But when a gorgeous, gallant, incredibly sexy billionaire ends up snowbound with her, Joy wishes she could tell Alexander Townsend the whole truth about herself. Especially when the one thing she shares is her bed—and then discovers he has as many trust issues as she does. Will keeping secrets cost Joy the best Christmas gift she’s ever received?<br/><br/><b>“Fans of forced proximity plots and billionaires with a soft heart will enjoy this sexy romance.” —<i>Harlequin Junkie</i></b><br/><br/><b>“A sexy and entertaining tale that readers won’t want to put down, grab a copy of <i>Snowed in with a Billionaire</i> today.” —<i>Romance Reviews Todayi</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Karen Booth
      </h2>
      
      <p class="authorDescription body article">Karen Booth is a Midwestern girl transplanted in the South, raised on &#39;80s music and way too many readings of &ldquo;Forever&rdquo; by Judy Blume. Married to her real-life Jake Ryan, she has two amazing kids with epic hair, a very bratty cat, and loves getting up before dawn to write romance. With plenty of sparks.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?19482d34